import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import "../../App.css";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="experience">
        
      
          <Col md={12} className="home-about-description" >
            <h1 className="project-heading" style={{ fontSize: "2.6em", textAlign:'center'}}>
          Experience
            </h1>
           
          </Col>
        
       
     

      <div class="container">
        <div class="timeline">
          <div class="timeline-row">
            <div class="timeline-time">Jan 2023 - Dec 2023</div>
            <div class="timeline-content">
              <h4 className="heading-timeline" style={{ color: "white" }}>Exact IT Solutions (Software Engineer)</h4>
              <p style={{ fontSize: 16, color: "white", textAlign: "left" }}>
                Website Development and More Functionality: Proficient in
                creating multiple websites with top-tier ecommerce capabilities,
                stunning front-end designs, and extensive libraries, including
                advanced email features. A track record of delivering robust
                online solutions that drive business growth.
               <br/>
                <br />
                Website Maintenance and Feature Enhancement: As an
                experienced developer, I have successfully maintained and
                enhanced numerous websites. I've adeptly managed regular
                updates, bug fixes, and feature improvements, ensuring websites
                remain secure and up-to-date.
              </p>
            </div>
          </div>

          <div class="timeline-row">
            <div class="timeline-time">October 2022 - Dec 2022 (Internship)</div>
            <div class="timeline-content">
              <h4 className="heading-timeline" style={{ color: "white" }}>Aimbrill (Frontend Developer) </h4>
              <p style={{ fontSize: 16, color: "white", textAlign: "left" }}>
              Developed a dynamic React website with a sleek and intuitive user interface using Material-UI. Designed an engaging signup/login form that ensures a seamless user experience. Leveraged Material-UI's components for creating a modern and responsive frontend, offering both visual appeal and functionality. 
                <br />
               
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
export default Home2;
